import { InsuranceType, isValidInsuranceType } from '@Framework/constants/InsuranceType';
import { useParams } from 'react-router-dom';

export function useInsuranceTypeParam(
  currentInsuranceType: InsuranceType | undefined,
  insuranceTypeSetter: (t: InsuranceType) => void,
  defaultInsuranceType?: InsuranceType
) {
  const { insurance: urlInsurance } = useParams<{ insurance: string }>();
  // url param overrides the already set insurance type if there's any
  if (urlInsurance !== undefined && isValidInsuranceType(urlInsurance)) {
    if (urlInsurance !== currentInsuranceType) {
      insuranceTypeSetter(urlInsurance);
    }
  }
  // a default value for the insurance type can be set if it's not already set
  else if (!currentInsuranceType && defaultInsuranceType) {
    insuranceTypeSetter(defaultInsuranceType);
  }
}
